export default __webpack_public_path__ + "static/media/3463.bba919ae.png";